import type { GID } from "@unlikelystudio/commerce-connector"

import type { Nullish } from "~/@types/generics"
import { SEARCH_FILTER_METAFIELD } from "~/lib/shopify/constants"
import { getSfCollectionProductsIds } from "~/lib/shopify/queries/get-sf-collection-products-ids"
import type { SbCollectionSchema } from "~/components/ui/Collection/_data/schema"
import { PRODUCTS_PER_PAGE } from "~/components/ui/Collection/CollectionDefault/constants"

export function getPushesEditoInCurrentPage(edito: SbCollectionSchema["edito"], currentPage: number) {
  return (
    edito?.filter(
      (e) =>
        e.position_in_grid > PRODUCTS_PER_PAGE * (currentPage - 1) &&
        e.position_in_grid <= PRODUCTS_PER_PAGE * currentPage
    ) ?? []
  )
}

export default async function getCollectionByIds({
  processedLocale,
  id,
  sbCollection,
}: {
  processedLocale: string
  id: Nullish<GID>
  sbCollection: Nullish<SbCollectionSchema>
}) {
  if (!id) {
    return null
  }

  let hasNextPage = true
  let page = 1
  let productsAfter

  let collectionByPage: Record<number, { ids: string[]; endCursor: Nullish<string>; editoCountInPage: number } | null> =
    {}

  do {
    const editoPushNumber = sbCollection?.edito ? getPushesEditoInCurrentPage(sbCollection?.edito, page).length : 0
    const { collectionProductsIds, productsIdsPageInfo } = await getSfCollectionProductsIds(
      {
        locale: processedLocale,
        id,
        productsFirst: PRODUCTS_PER_PAGE - editoPushNumber,
        productsAfter: productsAfter ?? undefined,
        productsFilters: [SEARCH_FILTER_METAFIELD]?.filter(Boolean),
      },
      {
        requestCacheOptions: { cache: "no-cache" },
      }
    )

    productsAfter = productsIdsPageInfo?.endCursor
    hasNextPage = productsIdsPageInfo?.hasNextPage ?? false

    collectionByPage[page] = {
      ids: collectionProductsIds,
      endCursor: productsIdsPageInfo?.endCursor ?? null,
      editoCountInPage: getPushesEditoInCurrentPage(sbCollection?.edito, page).length,
    }

    page++
  } while (hasNextPage)

  return collectionByPage
}
